import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { PrivateRoutes } from '../../../main/constant/RouteConstant';
import MessageConstant from '../../../main/constant/MessageConstant';

import { PatientUseCase } from '../../../data/useCase/PatientUseCase';

import { UseAlert } from '../../../presentation/hook/AlertHook';

import { AddPatient, EditPatient } from '../../../presentation/page/addPatient/AddPatientPageType';

import AddPatientPage from '../../../presentation/page/addPatient/AddPatientPage';

import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import { AddressUseCase } from '../../../data/useCase/AddressUseCase';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * AddPatientPageDomain - regra de negocio de Paciente
 * @constructor
 */
export const AddPatientPageDomain: React.FC = () => {
  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * endpoint
   */
  const ENDPOINT_PATIENT = EndpointsConstant.patient;

  /**
   * model
   */
  const [patient, setPatient] = useState<null>(null);

  /**
   * navegacao da url
   */
  let navigate = useNavigate();

  /**
   * parametros da url
   */
  const urlParams = useParams();

  /**
   * add
   * @param params
   */
  const add = async (params: AddPatient) => {
    await new PatientUseCase(`${ENDPOINT_PATIENT}/`)
      .Post({ data: params })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  /**
   * edit
   * @param params
   */
  const edit = async (params: EditPatient) => {
    await new PatientUseCase(`${ENDPOINT_PATIENT}/${params.id}`)
      .Put({ data: params })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  /**
   * comeBack - voltar
   */
  const comeBack = () => {
    navigate(PrivateRoutes.LIST_PATIENT);
  };

  /**
   * getPatient
   * @param id
   */
  const getPatient = async (id: number) => {
    await new PatientUseCase(`${ENDPOINT_PATIENT}/${id}`)
      .Get()
      .then((response) => {
        setPatient(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        showAlert({
          show: true,
          content: MessageConstant.erro.naoEncontrado,
          color: 'danger',
          time: 2000,
        });
      });
  };

  /**
   * inicia preenchendo o paciente caso tem um id na url
   */
  const init = async () => {
    if (urlParams.id) {
      await getPatient(Number(urlParams.id));
    }
  };

  /**
   * inicia a tela
   */
  useEffect(() => {
    init();
  }, []);

  /**
   * endpoint de endereço
   */
  const ENDPOINT_ADDRESS = EndpointsConstant.address;

  /**
   * model endereco
   */
  const [endereco, setEndereco] = useState<null>(null);

  const getAddress = async (cep: string) => {
    await new AddressUseCase(`${ENDPOINT_ADDRESS}/${cep}`)
      .Get()
      .then((response) => {
        console.info('RESPONSE: ', response);
        setEndereco(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
      });
  };

  return (
    <>
      <AddPatientPage add={add} comeBack={comeBack} patient={patient} getPatient={getPatient} edit={edit} getAddress={getAddress} address={endereco} />
    </>
  );
};
